jQuery(function($) {
  
  $(document).ready(function() {
    
    currencySync();
    viewportChecker();
    makeSticky();
    desktopNav();
    pushyNav();
    thumbFade();
    thumbZoom();
    itemBounce();
    animationClick();
    animationHover();
    dismissBtn();
    headerBanner();
    autoSizeTextArea();
    placeholderText();
    fitVideo();
    tabsItem();
    accordionItem();
    scrollTop();
    readMoreExp();
    smooothScroll();
    heroEffect();
    
  });
  
  
  
  $(window).on( 'load', function () {
    conformHeight();
  });
  
  
  
  $(window).on( 'resize', function () {
    conformHeight();
  });
  
  
  // Listen for changes done in the Theme Editor
  // https://shopify.dev/docs/themes/sections/develop-theme-sections-integration-with-theme-editor
  document.addEventListener("shopify:section:load", function(event) {
      fitVideo();
  });
  
  
  
  /*--------------------------------------------------
  Currency Converter Sync
  This keeps the Mobile and Desktop select menus in sync
  ---------------------------------------------------*/	
  function currencySync() {
    
    var $selects=$('#desktop-currency .currency-picker, #mobile-currency .currency-picker').change(function(){
      $selects.not(this).val( $(this).val() );
    })
    
  }// currencySync
  
  
  
  /*--------------------------------------------------
  Viewport Checker (used by the product grid)
  https://github.com/dirkgroenen/jQuery-viewport-checker
  ---------------------------------------------------*/	
  function viewportChecker() {
    
    $('.product').addClass("revealOnScroll").viewportChecker({
      classToAdd: 'revealed animate__animated animate__fadeIn', // Class to add to the elements when they are visible
      offset: 100 
    });
    
  }// viewportChecker
  
  
  
  /*--------------------------------------------------
  Sticky
  http://stickyjs.com
  ---------------------------------------------------*/	
  function makeSticky() {
    
    var windowWidth = $(window).innerWidth();
    
    // Display sticky buy buttons for mobile.
    // Only check the window width onload
    if (windowWidth <= 960) {
      $("#sticky-order").sticky({
        topSpacing: 0, // Don't use px here (ie: use 10 rather than 10px)
        responsiveWidth: true,
        center: true,
        zIndex: 9999 // (default: inherit) controls z-index of the sticked element.
      });
    }
    
  }// makeSticky
  
  
  
  /*--------------------------------------------------
  Desktop Navigation
  http://users.tpg.com.au/j_birch/plugins/superfish/#options
  ---------------------------------------------------*/	
  function desktopNav() {
    
    $("ul.sf-menu").superfish({
        popUpSelector: 'ul,.sf-mega',       // selector within menu context to define the submenu element to be revealed
        hoverClass:    'sfHover',           // the class applied to hovered list items
        pathClass:     'active-trail',      // the class you have applied to list items that lead to the current page
        pathLevels:    1,                   // the number of levels of submenus that remain open or are restored using pathClass
        delay:         600,                 // the delay in milliseconds that the mouse can remain outside a submenu without it closing
        animation:     {opacity:'show'},    // an object equivalent to first parameter of jQuery’s .animate() method. Used to animate the submenu open
        animationOut:  {opacity:'hide'},    // an object equivalent to first parameter of jQuery’s .animate() method Used to animate the submenu closed
        speed:         'normal',            // speed of the opening animation. Equivalent to second parameter of jQuery’s .animate() method
        speedOut:      'fast',              // speed of the closing animation. Equivalent to second parameter of jQuery’s .animate() method
        cssArrows:     true,                // set to false if you want to remove the CSS-based arrow triangles
        disableHI:     false                // set to true to disable hoverIntent detection
    });
    
  }// desktopNav
  
  
  
  /*--------------------------------------------------
  Pushy - Mobile Navigation
  https://chrisyee.ca/pushy/
  ---------------------------------------------------*/	
  function pushyNav() {
    
    
  }// pushyNav
  
  
  
  /*--------------------------------------------------
  Thumbnail Hover Effect
  ---------------------------------------------------*/	
  function thumbFade() {
    
    $('.image-fade-effect').hover(function(){
        $(this).stop().animate({opacity: 0.65});
    }, function() {
        $(this).stop().animate({opacity: 1});
    });
    
  }// thumbFade
  
  
  function thumbZoom() {
    
    $('.image-zoom-effect').hover(function() {
        $(this).addClass('transition-scale');
      }, function() {
        $(this).removeClass('transition-scale');
    });
  
  }// thumbZoom
  
  
  function itemBounce() {
    
    $('.bounce-effect').hover(function() {
        $(this).addClass('animated bounceIn');
      }, function() {
        $(this).removeClass('animated bounceIn');
    });
  
  }// itemBounce
  
  
  
  /*--------------------------------------------------
  Animate CSS
  https://daneden.github.io/animate.css/
  ---------------------------------------------------*/
  function animationClick(trigger, element, animation){
    element = $(element);
    trigger = $(trigger);
    trigger.click(
      function() {
        element.addClass('animate__animated ' + animation);
        // Wait for animation to finish before removing classes
        window.setTimeout( function(){
          element.removeClass('animate__animated ' + animation);
        }, 1000);
      });
  }
  
  function animationHover(trigger, element, animation){
    element = $(element);
    trigger = $(trigger);
    trigger.hover(
      function() {
        element.addClass('animate__animated ' + animation);
      },
      function(){
        // Wait for animation to finish before removing classes
        window.setTimeout( function(){
          element.removeClass('animate__animated ' + animation);
        }, 1000);
    });
  }
  
  animationHover('.post-preview', '.animated-icon',    'animate__zoomIn');
  animationHover('.promotions',   '.animated-caption', 'animate__zoomIn');
  animationHover('.product-preview-image',   '.animated-caption', 'animate__zoomIn');
  animationHover('.product-preview-image',   '.animated-icon',    'animate__zoomIn');
  
  
  
  /*--------------------------------------------------
  Dismiss Button
  ---------------------------------------------------*/	
  function dismissBtn() {
    
    $("a.dismiss-alert").click(function(){
      $(this).parent().fadeOut("slow");
        return false;
    });
    
  }// dismissBtn
  
  
  
  /*--------------------------------------------------
  Header Banner Visibility
  http://jsfiddle.net/FcFW2/1/
  ---------------------------------------------------*/	
  function headerBanner() {
    
    // If the cookie is not set we show the header banner.
    // re: Generic Cookies in theme-scripts.js
    if (!readCookie('header-banner-hide')) {
      $('#header-banner').show();
    }
    
    // Add the event that closes the header banner.
    // Set a cookie that tells us, not show it again until your next session.
    $('#promo-bar-close').click(function() {
      $('#header-banner').slideUp("slow");
      // Change the "0" value to 1, to hide the banner for 1 Day.
      createCookie('header-banner-hide', true, 0);
      return false;
    });
    
  }// headerBanner
  
  
  
  /*--------------------------------------------------
  Autosize TextArea
  http://www.jacklmoore.com/autosize
  ---------------------------------------------------*/	
  function autoSizeTextArea() {
    
    $(function(){
      autosize($('textarea'));
    });
    
  }// autoSizeTextArea
  
  
  
  /*--------------------------------------------------
  Form Placeholder Text (for older browsers)
  http://www.jacklmoore.com/notes/form-placeholder-text
  ---------------------------------------------------*/	
  function placeholderText() {
    
    function add() {
      if($(this).val() === ''){
        $(this).val($(this).attr('placeholder')).addClass('placeholder');
      }
    }
  
    function remove() {
      if($(this).val() === $(this).attr('placeholder')){
        $(this).val('').removeClass('placeholder');
      }
    }
  
    // Create a dummy element for feature detection
    if (!('placeholder' in $('<input>')[0])) {
    
      // Select the elements that have a placeholder attribute
      $('input[placeholder], textarea[placeholder]').blur(add).focus(remove).each(add);
    
    // Remove the placeholder text before the form is submitted
    $('form').submit(function(){
      $(this).find('input[placeholder], textarea[placeholder]').each(remove);
      });
    }
    
  }// placeholderText
  
  
  
  /*--------------------------------------------------
  FitVids
  http://fitvidsjs.com/
  ---------------------------------------------------*/	
  function fitVideo() {
    
    $(".main-content, article").fitVids();
    $(".video-wrapper").fitVids();
    $(".module-video").fitVids();
    $(".video-text-item").fitVids();
    
  }// fitVideo
  
  
  
  /*--------------------------------------------------
  Tabs
  http://www.jacklmoore.com/notes/jquery-tabs
  ---------------------------------------------------*/	
  function tabsItem() {
    
    $('ul.tabs').each(function(){
      // Keep track of which tab is active and it's associated content
      var $active, $content, $links = $(this).find('a');
      
      // Use the first link as the initial active tab
      $active = $links.first().addClass('current');
      $content = $($active.attr('href'));
      
      // Hide the remaining content
      $links.not(':first').each(function () {
        $($(this).attr('href')).hide();
      });
      
      // Bind the click event handler
      $(this).on('click', 'a', function(e){
        // Make the old tab inactive.
        $active.removeClass('current');
        $content.hide();
        
        // Update the variables with the new link and content
        $active = $(this);
        $content = $($(this).attr('href'));
        
        // Make the tab active
        $active.addClass('current');
        $content.show();
        
        // Prevent the anchor's default click action
        e.preventDefault();
      });
    });
    
  }// tabsItem
  
  
  
  /*--------------------------------------------------
  jQuery Accordion
  https://github.com/vctrfrnndz/jquery-accordion
  ---------------------------------------------------*/	
  function accordionItem() {
    
    $('.accordion [data-accordion]').accordion({
      transitionSpeed: 300,                     // Transition speed on miliseconds.
      transitionEasing: "ease",                 // CSS value for easing.
      controlElement: "[data-control]",         // CSS selector for the element acting as a button.
      contentElement: "[data-content]",         // CSS selector for the element containing hide/show content.
      groupElement: "[data-accordion-group]",   // CSS selector for a parent element containing a group.
      singleOpen: true                          // Opens a single accordion a time.
    });
    
  }// accordionItem
  
  
  
  /*--------------------------------------------------
  Scroll Up
  http://markgoodyear.com/2013/01/scrollup-jquery-plugin/
  ---------------------------------------------------*/	
  function scrollTop() {
    
    $.scrollUp({
      scrollName: 'scrollUp',                   // Element ID
      scrollDistance: 300,                      // Distance from top/bottom before showing element (px)
      scrollFrom: 'top',                        // 'top' or 'bottom'
      scrollSpeed: 300,                         // Speed back to top (ms)
      easingType: 'linear',                     // Scroll to top easing (see http://easings.net/)
      animation: 'fade',                        // Fade, slide, none
      animationInSpeed: 200,                    // Animation in speed (ms)
      animationOutSpeed: 200,                   // Animation out speed (ms)
      scrollText: '<span class="accent-icon-arrow-up" aria-hidden="true"></span>', // Text for element, can contain HTML
      scrollTitle: "Scroll to top", // Set a custom <a> title if required. Defaults to scrollText
      scrollImg: false,                         // Set true to use image
      activeOverlay: false,                     // Set CSS color to display scrollUp active point, e.g '#00FFFF'
      zIndex: 88888                             // Z-Index for the overlay
    });
    
  }// scrollTop
  
  
  
  /*--------------------------------------------------
  Read More
  https://github.com/jedfoster/Readmore.js
  
  Text fading option
  https://github.com/jedfoster/Readmore.js/issues/141
  Be sure to use the same speed value in your CSS transition property.
  ---------------------------------------------------*/	
  function readMoreExp() {
    
    $('.read-more-copy').readmore({
      speed: 500,                               // in milliseconds 
      collapsedHeight: 300,                     // in pixels
      heightMargin: 16,                         // in pixels, avoids collapsing blocks that are only slightly larger than collapsedHeight
      moreLink: '<a href="#">Read more</a>',
      lessLink: '<a href="#">Read less</a>',
      embedCSS: true,                           // insert required CSS dynamically, set this to false if you include the necessary CSS in a stylesheet
      blockCSS: 'display: block; width: 100%;', // sets the styling of the blocks, ignored if embedCSS is false
      startOpen: false,                         // do not immediately truncate, start in the fully opened position
      
      // Add the class 'transitioning' before toggling begins.
      beforeToggle: function(trigger, element, expanded) {
          element.addClass('transitioning');
      },
      // Remove the 'transitioning' class when toggling completes.
      afterToggle: function(trigger, element, expanded) {
        element.removeClass('transitioning');
      }
      
    });
    
  }// readMoreExp
  
  
  
  /*--------------------------------------------------
  Smooth Scrolling
  https://css-tricks.com/snippets/jquery/smooth-scrolling/
  
  See alteration:
  https://css-tricks.com/snippets/jquery/smooth-scrolling/#comment-1587650
  ---------------------------------------------------*/	
  function smooothScroll() {
    
    $(function() {
      $("a[rel^='scrolling']").click(function() {
        if (location.pathname.replace(/^\//,'') === this.pathname.replace(/^\//,'') && location.hostname === this.hostname) {
          var target = $(this.hash);
          target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
          if (target.length) {
            $('html,body').animate({
              scrollTop: target.offset().top
            }, 1000);
            return false;
          }
        }
      });
    });
    
  }// smooothScroll
  
  
  
  /*--------------------------------------------------
  Conformity
  For equal height elements based on row rather than set.
  https://github.com/codekipple/conformity
  ---------------------------------------------------*/	
  function conformHeight() {
    
    // Used by various "Product" image grids
    $('.image-grid-uniform .product-grid-item').conformity();
    // Used by various "Collection" image grids
    $('.image-grid-uniform .collection-grid-item').conformity();
    
  }// conformHeight
  
  
  
  /*--------------------------------------------------
  Hero Effect
  Applied to the featured Article image when scrolling
  https://codepen.io/magnificode/pen/GpqGOm
  ---------------------------------------------------*/
  function heroEffect() {
    
    var hero = $('.hero-feature'),
      heroInner = $('.hero-feature__inner'),
      // The initial .hero-feature is defined in CSS
      heroHeight = $('.hero-feature').outerHeight(true); 
    $(window).scroll(function() {
      // ScrollOffset starts at 0 and increases as we scroll down the page.
      var scrollOffset = $(window).scrollTop();
      if (scrollOffset < heroHeight) {
          // The heroHeight descreses as the scrollOffset increases.
          // The two values are equal when the heroHeight is reduced by 50%
          $(hero).css('height', (heroHeight - scrollOffset));
      }
      // Once the heroHeight is reduced by 50%
      if (scrollOffset > (heroHeight / 2)) {
          heroInner.addClass('dimmer');
      } else {
          heroInner.removeClass('dimmer');
      }
    });
  
  }// heroEffect
  
  
  
  
});


// SCROLLING
$(document).scroll(function() {

  //$('#sticky-header').addClass('locked');
  
  // We need to calculate an offset to stop the page from jumping
  // when you start scrolling
  
  //headerHeight = $('#sticky-header').outerHeight(true); 

  if($(document).scrollTop() >= 1 ) {
    //$('#sticky-header').addClass('locked');
  } else {
   // $('#sticky-header').removeClass('locked');
  }
  if($(document).scrollTop() >= 1) {
    //$('#sticky-header').addClass('scrolled');
    //$("#main").css("margin-top", headerHeight);
  } else {
    //$('#sticky-header').removeClass('scrolled');
    //$("#main").css("margin-top", "0");
  }

});


/*--------------------------------------------------
Masonry
http://masonry.desandro.com/options.html
http://masonry.desandro.com/layout.html#imagesloaded
---------------------------------------------------*/	
var $grid = $('.image-grid-masonry').imagesLoaded( function() {
  // init Masonry after all images have loaded
  $grid.masonry({
    columnWidth: '.masonry-sizer',
    itemSelector: '.masonry-item',
    percentPosition: true,
    transitionDuration: '0s'
  });
});



/*--------------------------------------------------
A11yDialog
https://github.com/edenspiekermann/a11y-dialog
---------------------------------------------------*/
(function () {
  document.addEventListener('DOMContentLoaded', function () {
    
    var dialogEl = document.getElementById('search-dialog');
    var mainEl = document.getElementById('main');
    var dialog = new window.A11yDialog(dialogEl, mainEl);
    
  });
}());

function isAnyDialogShown() {
  return !!$$('.dialog').filter(function(dialog) { return !dialog.getAttribute('aria-hidden'); }).length;
}


/*--------------------------------------------------
Plus Minus
---------------------------------------------------*/
$(document).ready(function() {
  
  $('.minus-link').click(function () {
    var $input = $(this).parent().find('input');
    var count = parseInt($input.val()) - 1;
    count = count < 1 ? 1 : count;
    $input.val(count);
    $input.change();
    return false;
  });
  
  $('.plus-link').click(function () {
    var $input = $(this).parent().find('input');
    $input.val(parseInt($input.val()) + 1);
    $input.change();
    return false;
  });
  
});






/*  TIMBER JS
/*  http://shopify.github.io/Timber/
/*  ________________________________ */

/* Jonathan Snook - MIT License - https://github.com/snookca/prepareTransition */
(function(a){a.fn.prepareTransition=function(){return this.each(function(){var b=a(this);b.one("TransitionEnd webkitTransitionEnd transitionend oTransitionEnd",function(){b.removeClass("is-transitioning")});var c=["transition-duration","-moz-transition-duration","-webkit-transition-duration","-o-transition-duration"];var d=0;a.each(c,function(a,c){d=parseFloat(b.css(c))||d});if(d!=0){b.addClass("is-transitioning");b[0].offsetWidth}})}})(jQuery);

/* replaceUrlParam - http://stackoverflow.com/questions/7171099/how-to-replace-url-parameter-with-javascript-jquery */
function replaceUrlParam(e,r,a){var n=new RegExp("("+r+"=).*?(&|$)"),c=e;return c=e.search(n)>=0?e.replace(n,"$1"+a+"$2"):c+(c.indexOf("?")>0?"&":"?")+r+"="+a};

/*============================================================================
  Money Format
  Shopify.format money is defined in option_selection.js.
  If that file is not included, it is redefined here.
==============================================================================*/
if ((typeof Shopify) === 'undefined') { Shopify = {}; }
if (!Shopify.formatMoney) {
  Shopify.formatMoney = function(cents, format) {
    var value = '',
        placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
        formatString = (format || this.money_format);

    if (typeof cents == 'string') {
      cents = cents.replace('.','');
    }

    function defaultOption(opt, def) {
      return (typeof opt == 'undefined' ? def : opt);
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal   = defaultOption(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number/100.0).toFixed(precision);

      var parts   = number.split('.'),
          dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
          cents   = parts[1] ? (decimal + parts[1]) : '';

      return dollars + cents;
    }

    switch(formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  };
}

// Timber functions
window.timber = window.timber || {};

timber.cacheSelectors = function () {
  timber.cache = {
    // General
    $html                    : $('html'),
    $body                    : $(document.body),

    // Navigation
    $navigation              : $('#AccessibleNav'),
    $mobileSubNavToggle      : $('.mobile-nav__toggle'),

    // Collection Pages
    $changeView              : $('.change-view'),

    // Product Page
    $productImage            : $('#ProductPhotoImg'),
    $thumbImages             : $('#ProductThumbs').find('a.product-single__thumbnail'),

    // Customer Pages
    $recoverPasswordLink     : $('#RecoverPassword'),
    $hideRecoverPasswordLink : $('#HideRecoverPasswordLink'),
    $recoverPasswordForm     : $('#RecoverPasswordForm'),
    $customerLoginForm       : $('#CustomerLoginForm'),
    $passwordResetSuccess    : $('#ResetSuccess')
  };
};

timber.init = function () {
  FastClick.attach(document.body);
  timber.cacheSelectors();
  timber.accessibleNav();
  timber.drawersInit();
  timber.mobileNavToggle();
  timber.productImageSwitch();
  timber.responsiveVideos();
  timber.collectionViews();
  timber.loginForms();
};

timber.accessibleNav = function () {
  var $nav = timber.cache.$navigation,
      $allLinks = $nav.find('a'),
      $topLevel = $nav.children('li').find('a'),
      $parents = $nav.find('.site-nav--has-dropdown'),
      $subMenuLinks = $nav.find('.site-nav__dropdown').find('a'),
      activeClass = 'nav-hover',
      focusClass = 'nav-focus';

  // Mouseenter
  $parents.on('mouseenter touchstart', function(evt) {
    var $el = $(this);

    if (!$el.hasClass(activeClass)) {
      evt.preventDefault();
    }

    showDropdown($el);
  });

  // Mouseout
  $parents.on('mouseleave', function() {
    hideDropdown($(this));
  });

  $subMenuLinks.on('touchstart', function(evt) {
    // Prevent touchstart on body from firing instead of link
    evt.stopImmediatePropagation();
  });

  $allLinks.focus(function() {
    handleFocus($(this));
  });

  $allLinks.blur(function() {
    removeFocus($topLevel);
  });

  // accessibleNav private methods
  function handleFocus ($el) {
    var $subMenu = $el.next('ul'),
        hasSubMenu = $subMenu.hasClass('sub-nav') ? true : false,
        isSubItem = $('.site-nav__dropdown').has($el).length,
        $newFocus = null;

    // Add focus class for top level items, or keep menu shown
    if (!isSubItem) {
      removeFocus($topLevel);
      addFocus($el);
    } else {
      $newFocus = $el.closest('.site-nav--has-dropdown').find('a');
      addFocus($newFocus);
    }
  }

  function showDropdown ($el) {
    $el.addClass(activeClass);

    setTimeout(function() {
      timber.cache.$body.on('touchstart', function() {
        hideDropdown($el);
      });
    }, 250);
  }

  function hideDropdown ($el) {
    $el.removeClass(activeClass);
    timber.cache.$body.off('touchstart');
  }

  function addFocus ($el) {
    $el.addClass(focusClass);
  }

  function removeFocus ($el) {
    $el.removeClass(focusClass);
  }
};

timber.drawersInit = function () {
  timber.LeftDrawer = new timber.Drawers('NavDrawer', 'left');
  
};

timber.mobileNavToggle = function () {
  timber.cache.$mobileSubNavToggle.on('click', function() {
    $(this).parent().toggleClass('mobile-nav--expanded');
  });
};

timber.getHash = function () {
  return window.location.hash;
};

timber.productPage = function (options) {
  var moneyFormat = options.money_format,
      variant = options.variant,
      selector = options.selector;

  // Selectors
  var $productImage = $('#ProductPhotoImg'),
      $addToCart = $('#AddToCart'),
      $productPrice = $('#ProductPrice'),
      $comparePrice = $('#ComparePrice'),
      $comparePriceAlt = $('#ComparePriceAlt'),
      $quantityElements = $('.quantity-selector, label + .js-qty'),
      $addToCartText = $('#AddToCartText');

  if (variant) {

    // Update variant image, if one is set
    if (variant.featured_image) {
      var newImg = variant.featured_image,
          el = $productImage[0];
      Shopify.Image.switchImage(newImg, el, timber.switchImage);
    }

    // Select a valid variant if available
    if (variant.available) {
      // Available, enable the submit button, change text, show quantity elements
      $addToCart.removeClass('disabled').prop('disabled', false);
      $addToCartText.html("Add to cart");
      $quantityElements.show();
    } else {
      // Sold out, disable the submit button, change text, hide quantity elements
      $addToCart.addClass('disabled').prop('disabled', true);
      $addToCartText.html("Sold out");
      $quantityElements.hide();
    }

    // Regardless of stock, update the product price
    $productPrice.html( Shopify.formatMoney(variant.price, moneyFormat) );

    // Also update and show the product's compare price if necessary
    if (variant.compare_at_price > variant.price) {
      $comparePrice
        .html("Compare at:" + ' ' + Shopify.formatMoney(variant.compare_at_price, moneyFormat))
        .show();
      $comparePriceAlt
        .html(Shopify.formatMoney(variant.compare_at_price, moneyFormat))
        .show();
    } else {
      $comparePrice.hide();
      $comparePriceAlt.hide();
    }

  } else {
    // The variant doesn't exist, disable submit button.
    // This may be an error or notice that a specific variant is not available.
    // To only show available variants, implement linked product options:
    //   - http://docs.shopify.com/manual/configuration/store-customization/advanced-navigation/linked-product-options
    $addToCart.addClass('disabled').prop('disabled', true);
    $addToCartText.html("Unavailable");
    $quantityElements.hide();
  }
};

timber.productImageSwitch = function () {
  if (timber.cache.$thumbImages.length) {
    // Switch the main image with one of the thumbnails
    // Note: this does not change the variant selected, just the image
    timber.cache.$thumbImages.on('click', function(evt) {
      evt.preventDefault();
      var newImage = $(this).attr('href');
      timber.switchImage(newImage, null, timber.cache.$productImage);
    });
  }
};

timber.switchImage = function (src, imgObject, el) {
  // Make sure element is a jquery object
  var $el = $(el);
  $el.attr('src', src);
};

timber.responsiveVideos = function () {
  var $iframeVideo = $('iframe[src*="youtube.com/embed"], iframe[src*="player.vimeo"]');
  var $iframeReset = $iframeVideo.add('iframe#admin_bar_iframe');
  
  $iframeVideo.each(function () {
    // Add wrapper to make video responsive
    $(this).wrap('<div class="video-wrapper"></div>');
  });
  
  $iframeReset.each(function () {
    // Re-set the src attribute on each iframe after page load
    // for Chrome's "incorrect iFrame content on 'back'" bug.
    // https://code.google.com/p/chromium/issues/detail?id=395791
    // Need to specifically target video and admin bar
    this.src = this.src;
  });
};

timber.collectionViews = function () {
  if (timber.cache.$changeView.length) {
    timber.cache.$changeView.on('click', function() {
      var view = $(this).data('view'),
          url = document.URL,
          hasParams = url.indexOf('?') > -1;
          
      if (hasParams) {
        window.location = replaceUrlParam(url, 'view', view);
      } else {
        window.location = url + '?view=' + view;
      }
    });
  }
};

timber.loginForms = function() {
  function showRecoverPasswordForm() {
    timber.cache.$recoverPasswordForm.show();
    timber.cache.$customerLoginForm.hide();
  }
  
  function hideRecoverPasswordForm() {
    timber.cache.$recoverPasswordForm.hide();
    timber.cache.$customerLoginForm.show();
  }
  
  timber.cache.$recoverPasswordLink.on('click', function(evt) {
    evt.preventDefault();
    showRecoverPasswordForm();
  });

  timber.cache.$hideRecoverPasswordLink.on('click', function(evt) {
    evt.preventDefault();
    hideRecoverPasswordForm();
  });

  // Allow deep linking to recover password form
  if (timber.getHash() == '#recover') {
    showRecoverPasswordForm();
  }
};

timber.resetPasswordSuccess = function() {
  timber.cache.$passwordResetSuccess.show();
};

/*============================================================================
  Drawer modules
  - Docs http://shopify.github.io/Timber/#drawers
==============================================================================*/
timber.Drawers = (function () {
  var Drawer = function (id, position, options) {
    var defaults = {
      close: '.js-drawer-close',
      open: '.js-drawer-open-' + position,
      openClass: 'js-drawer-open',
      dirOpenClass: 'js-drawer-open-' + position
    };

    this.$nodes = {
      parent: $('body, html'),
      page: $('#PageContainer'),
      moved: $('.is-moved-by-drawer')
    };

    this.config = $.extend(defaults, options);
    this.position = position;

    this.$drawer = $('#' + id);

    if (!this.$drawer.length) {
      return false;
    }

    this.drawerIsOpen = false;
    this.init();
  };

  Drawer.prototype.init = function () {
    $(this.config.open).on('click', $.proxy(this.open, this));
    this.$drawer.find(this.config.close).on('click', $.proxy(this.close, this));
  };

  Drawer.prototype.open = function (evt) {
    // Keep track if drawer was opened from a click, or called by another function
    var externalCall = false;

    // Prevent following href if link is clicked
    if (evt) {
      evt.preventDefault();
    } else {
      externalCall = true;
    }

    // Without this, the drawer opens, the click event bubbles up to $nodes.page
    // which closes the drawer.
    if (evt && evt.stopPropagation) {
      evt.stopPropagation();
      // save the source of the click, we'll focus to this on close
      this.$activeSource = $(evt.currentTarget);
    }

    if (this.drawerIsOpen && !externalCall) {
      return this.close();
    }

    // Add is-transitioning class to moved elements on open so drawer can have
    // transition for close animation
    this.$nodes.moved.addClass('is-transitioning');
    this.$drawer.prepareTransition();

    this.$nodes.parent.addClass(this.config.openClass + ' ' + this.config.dirOpenClass);
    this.drawerIsOpen = true;

    // Run function when draw opens if set
    if (this.config.onDrawerOpen && typeof(this.config.onDrawerOpen) == 'function') {
      if (!externalCall) {
        this.config.onDrawerOpen();
      }
    }

    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'true');
    }

    // Lock scrolling on mobile
    this.$nodes.page.on('touchmove.drawer', function () {
      return false;
    });

    this.$nodes.page.on('click.drawer', $.proxy(function () {
      this.close();
      return false;
    }, this));
  };

  Drawer.prototype.close = function () {
    if (!this.drawerIsOpen) { // don't close a closed drawer
      return;
    }

    // deselect any focused form elements
    $(document.activeElement).trigger('blur');

    // Ensure closing transition is applied to moved elements, like the nav
    this.$nodes.moved.prepareTransition({ disableExisting: true });
    this.$drawer.prepareTransition({ disableExisting: true });

    this.$nodes.parent.removeClass(this.config.dirOpenClass + ' ' + this.config.openClass);

    this.drawerIsOpen = false;

    this.$nodes.page.off('.drawer');
  };

  return Drawer;
})();

// Initialize Timber's JS on docready
$(timber.init);
